import AWS from 'aws-sdk';
import awsConfig from './config.json';

// Load in email body templates
const contactUsTemplate = require('./templates/contactUs');

function sesAuth() {
  // Load the AWS SDK for Node.js
  AWS.config.update(awsConfig);
}

function sendEmail(params) {
  const ses = new AWS.SES({ apiVersion: '2010-12-01' });
  const sendEmail = ses.sendEmail(params).promise();

  sendEmail.then(() => {
    console.log('email submitted to SES');
  }).catch((error) => {
    console.log(error);
  });
}

function contactUs(emailPackage) {
  // Get auth to use AWS SES emailer
  sesAuth();
  const clientEmail = emailPackage.emailData.email;
  // Check to see if the customer provided their email and email them a response if they did.
  if (clientEmail) {
    // Create sendEmail params
    const params = {
      Destination: { /* required */
        ToAddresses: [
          clientEmail,
        ],
      },
      ConfigurationSetName: 'II-Contact-Us-Form',
      Message: { /* required */
        Body: { /* required */
          Html: {
            Charset: 'UTF-8',
            Data: contactUsTemplate.contactUsCustomerHTML(emailPackage),
          },
          Text: {
            Charset: 'UTF-8',
            Data: contactUsTemplate.contactUSCustomerText(emailPackage),
          },
        },
        Subject: {
          Charset: 'UTF-8',
          Data: 'Ingalls Image | Thank you for reaching out to us!',
        },
      },
      Source: process.env.VUE_APP_NOREPLY_EMAIL, /* required */
    };
    sendEmail(params);
  }
  // Send email to Ingalls Image alerting of new contact us form submission
  // Create sendEmail params
  const params = {
    Destination: { /* required */
      ToAddresses: [
        process.env.VUE_APP_CONTACT_EMAIL,
      ],
    },
    ConfigurationSetName: 'II-Contact-Us-Form',
    Message: { /* required */
      Body: { /* required */
        Html: {
          Charset: 'UTF-8',
          Data: contactUsTemplate.contactUsIIHTML(emailPackage),
        },
        Text: {
          Charset: 'UTF-8',
          Data: contactUsTemplate.contactUsIIText(emailPackage),
        },
      },
      Subject: {
        Charset: 'UTF-8',
        Data: `Contact Us Submission - from ${emailPackage.emailData.name}`,
      },
    },
    Source: process.env.VUE_APP_CONTACT_EMAIL, /* required */
  };
  sendEmail(params);
}

export function emailControl(emailPackage) {
  // If the email is a contact email, emailType === 1
  if (emailPackage.emailType === 1) {
    contactUs(emailPackage);
  } else {
    return false;
  }
}

export function testEmail() {
}
